import { Loader2 } from 'lucide-react';

/**
 * Shown while the API does not answer at the network level (local stack
 * still booting, backend restarting). The profile query polls in the
 * background, so this screen resolves itself when the backend comes up.
 */
export function BackendUnreachable() {
  return (
    <div
      role="status"
      className="flex min-h-64 flex-col items-center justify-center gap-3 p-8 text-center"
    >
      <Loader2 aria-hidden className="size-6 animate-spin text-muted-foreground" />
      <p className="text-base font-medium">The backend is not reachable</p>
      <p className="text-sm text-muted-foreground">
        It is probably still starting. The app retries automatically.
      </p>
    </div>
  );
}
